<template>
  <div class="full-height d-flex flex-column ">

    <pc-header activeIndex="sign-in"></pc-header>
    <div class="container">
      <div class="row">
        <div class="col">
          <h4 class="mt-5 ml-4">Sign in to your account</h4>
          <el-form ref="form" class="mt-4" label-width="120px" style="max-width: 500px">
            <el-form-item label="E-Mail">
              <el-input v-model="email"></el-input>
            </el-form-item>
            <el-form-item label="Password">
              <el-input type="password" autocomplete="new-password" v-model="password"></el-input>
            </el-form-item>


            <el-form-item>
              <router-link class="forget-password" :to="'reset-password'">Forgot your password?</router-link>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-loading="loading" @click="startSignIn">Sign In</el-button>
              <span class="text-danger pl-2">{{sign_in_error}}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
  import PcHeader from '../components/pc-header.component'
  import {mapActions, mapState} from 'vuex'
  import {track} from '../ga-events'
  import PcFooter from '../views/PcFooter'

  export default {
    name: 'sing-in',
    components: {
      PcFooter,
      PcHeader,
    },
    data () {
      return {
        loading: false,
        email: '',
        password: '',
      }
    },
    computed: {
      ...mapState(['count', 'sign_in_error', 'is_logged_in']),
    },
    methods: {
      ...mapActions(['willSignIn']),
      async startSignIn () {
        console.log(this.is_logged_in)

        track('my_profile', 'will_sign_in', this.email)
        try {
          this.loading = true
          await this.willSignIn({
            email: this.email,
            password: this.password,
          })
        } finally {
          this.loading = false
        }
        if (this.is_logged_in) {
          track('my_profile', 'sign_in_success', this.email)
          this.$router.push('/my-profile')
        }
      },
    },
  }
</script>

<style scoped>
  .full-height {
    min-height: 100vh;
    flex-direction: column;
  }
</style>